import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CustomerAuditIcon, DashboardIcon, Report, HandleMemberQueryIcon, PointsManagementIcon, PointsAwardIcon, TransactionChannelIcon, PointsApprovalsIcon } from "../assets/icons";
import styles from "../styles/Sidebar.module.scss";
import logo from "../assets/images/fb-logo.png";
import perx from "../assets/images/Perx-logo.png";
import useLocalStorage from "../hooks/useLocalStorage";
import { useDispatch, useSelector } from "react-redux";
import { setActiveReport } from "../hooks/Redux/Fetures/DashboardActiveSlice";
import Cookies from "js-cookie";

const Sidebar = ({ closeNav }) => {
  const activeReport = useSelector(
    (state) => state?.dashboardActivePage?.activeReport
  );

  const currentURL = window.location.href;
  const linkValue = currentURL.split("/")?.length - 1;
  const currentPage = currentURL.split("/")[linkValue];
  const parentPage = currentURL.split("/")[linkValue - 1];
  const { getLocalStorage } = useLocalStorage();
  const usersPreviledge = getLocalStorage("priviledges");
  const dispatch = useDispatch();
  const [activeLink, setActiveLink] = useState("/");
  const [isOpen, setIsOpen] = useState(false);
  const [isPointsAwardOpen, setIsPointsAwardOpen] = useState(false);
  const navigate = useNavigate();

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const togglePointsAwardDropdown = () => {
    setIsPointsAwardOpen(!isPointsAwardOpen);
  };

  const handleLinkClick = (linkName) => {
    setActiveLink(linkName);
  };

  // handle logout
  const handleLogoutFn = () => {
    localStorage.clear()
    Cookies.remove("token")
    // navigate("/")

  }

  useEffect(() => {
    if (currentPage === "") {
      setActiveLink("/dashboard");
    } else if (currentPage === "customer-audit-log") {
      setActiveLink("customer-audit-log");
    } else if (currentPage === "handle-member-query" || parentPage === 'handle-member-query') {
      setActiveLink("handle-member-query");
    } else if (currentPage === "points-management") {
      setActiveLink("points-management");
    } else if (parentPage === "points-award") {
      setActiveLink("points-award");
    } else if (currentPage === "admin-audit-log") {
      setActiveLink("admin-audit-log");
    } else if (currentPage === "transaction-channel") {
      setActiveLink("transaction-channel");
    } else if (currentPage === "transaction-channel") {
      setActiveLink("transaction-channel");
    } else if (currentPage === "points-approvals" || parentPage === "points-approvals") {
      setActiveLink("points-approvals");
    } else {
      setActiveLink("report");
    }
  }, [currentPage, parentPage]);

  const workingDashboardReports = [
    "Create Member Enrollment Report",
    // "Create Campaign Report",
    "Partner Redemption Report",
    "Liability report",
    "Call Center Reports",
    //"Create Points Forfeiture Report",
    "Create Company Points Liability Report",
    "Create Member Transaction Report",
  ];

  // const handleMemberQueryPrivilege = usersPreviledge.find(
  //   (item) => item.Menu_name === "Handle Member Query"
  // );

  // NEW SIDEBAR MENU
  // const filteredMenu = usersPreviledge.filter((item) =>
  //   workingDashboardReports.includes(item.Menu_name)
  // );

  const handleMemberQueryPrivilege = usersPreviledge?.find(
    (item) => item.Menu_name === "Handle Member Query"
  );

  const filteredMenu = (usersPreviledge ?? []).filter((item) =>
    workingDashboardReports.includes(item.Menu_name)
  );

  const userEmail = localStorage.getItem("userEmail");

  const restrictedEmails = [
    "Iyaye.iberiyenari@firstbanknigeria.com",
    "Sodiq.Adeleke@firstbankgroup.com",
    "Ibrahim.Ojo@firstbankgroup.com",
    "Olaoluwa.J.Ogunduyi@firstbankgroup.com",
    "Olarenwaju.S.Yaya@firstbankgroup.com",
    "Godson.Emeh@firstbankgroup.com",
  ];

  const isRestrictedUser = restrictedEmails.some(
    (email) => email.toLowerCase() === userEmail?.toLowerCase()
  );

  const makerEmails = [
    "Inalegwu.Alechenu@firstbankgroup.com",
    "sn031800@firstbanknigeria.com",
    "Olukayode.P.Adejumo@firstbankgroup.com",
    "Ikechukwu.N.Egbulonu@firstbankgroup.com",
    "rilwan.adebayo@loyaltysolutionsnigeria.com",
  ];

  const isMaker = makerEmails.some(
    (email) => email.toLowerCase() === userEmail?.toLowerCase()
  );

  return (
    <div className={styles.Sidebar}>
      <div className={styles.sidebar}>
        <div className={styles.logoContainer}>
          <img src={logo} alt="logo" />
        </div>
        <Link
          to="/dashboard"
          className={activeLink === "/dashboard" && styles.active}
          // onClick={() => handleLinkClick("/")}
          onClick={() => {
            dispatch(setActiveReport(0));
            closeNav(false);
          }}
        >
          <div className={styles.innerLink}>
            <DashboardIcon activeLink={activeLink} /> Dashboard
          </div>
        </Link>
        <Link
          to="/transaction-channel"
          className={`${styles.link} ${activeLink === "transaction-channel" && styles.active}`}
          onClick={() => handleLinkClick("transaction-channel")}
        >
          <div className={styles.innerLink}>
            <TransactionChannelIcon activeLink={activeLink} /> Transaction Channel
          </div>
        </Link>
        {!isRestrictedUser && (
          <Link
            to="/customer-audit-log"
            className={activeLink === "customer-audit-log" && styles.active}
            onClick={() => {
              dispatch(setActiveReport(0), console.log("clicked"));
              closeNav(false);
            }}
          // onClick={() => handleLinkClick("customer-audit-log")}
          >
            <div className={styles.innerLink}>
              <CustomerAuditIcon activeLink={activeLink} /> Customer Audit Log
            </div>
          </Link>
        )}
        {!isRestrictedUser && handleMemberQueryPrivilege && (
          <Link
            to="/handle-member-query"
            className={activeLink === "handle-member-query" && styles.active}
            onClick={() => {
              handleLinkClick("handle-member-query");
              closeNav(false);
            }}
          >
            <div className={styles.innerLink}>
              <HandleMemberQueryIcon activeLink={activeLink} /> Handle Member Query
            </div>
          </Link>
        )}
        {!isRestrictedUser && (
          <Link
            to="/points-management"
            className={activeLink === "points-management" && styles.active}
            onClick={() => {
              handleLinkClick("points-management");
              closeNav(false);
            }}
          >
            <div className={styles.innerLink}>
              <PointsManagementIcon /> Points Management
            </div>
          </Link>
        )}
        {!isRestrictedUser && (
          <Link
            to="/points-approvals"
            className={activeLink === "points-approvals" && styles.active}
            onClick={() => {
              handleLinkClick("points-approvals");
              closeNav(false);
            }}
          >
            <div className={styles.innerLink}>
              <PointsApprovalsIcon activeLink={activeLink} /> Points approvals
            </div>
          </Link>
        )}
        {isMaker && (
          <Link
            to="/reset-enrolment"
            className={`${styles.link} ${activeLink === "reset-enrolment" && styles.active}`}
            onClick={() => handleLinkClick("reset-enrolment")}
          >
            <div className={styles.innerLink}>
              <HandleMemberQueryIcon activeLink={activeLink} /> Reset Enrolment
            </div>
          </Link>
        )}
        {!isRestrictedUser && (
          <div className={styles.dropdown}>
            <Link
              to="/points-award/transactions"
              className={`${styles.dropdownToggle} ${activeLink === "points-award" && styles.active
                }`}
              onClick={() => {
                togglePointsAwardDropdown();
                handleLinkClick("points-award");
              }}
            >
              <div className={styles.innerLink}>
                <PointsAwardIcon activeLink={activeLink} /> Points Award
              </div>
            </Link>

            {isPointsAwardOpen && (
              <ul className={styles.dropdownMenu}>
                <li
                  className="text-gray-300 px-8 pt-2 pb-3 text-[13px] cursor-pointer"
                  onClick={() => {
                    navigate("/points-award/transactions");
                    closeNav(false);
                  }}
                >
                  Transactions
                </li>
                <li
                  className="text-gray-300 px-8 pt-2 pb-3 text-[13px] cursor-pointer"
                  onClick={() => {
                    navigate("/points-award/audit-log");
                    closeNav(false);
                  }}
                >
                  Audit log
                </li>
                <li
                  className="text-gray-300 px-8 pt-2 pb-3 text-[13px] cursor-pointer"
                  onClick={() => {
                    navigate("/points-award/reports");
                    closeNav(false);
                  }}
                >
                  Reports
                </li>
              </ul>
            )}
          </div>
        )}
        {!isRestrictedUser && (
          <Link
            to="/admin-audit-log"
            className={activeLink === "admin-audit-log" && styles.active}
            onClick={() => {
              handleLinkClick("admin-audit-log");
              closeNav(false);
            }}
          >
            <div className={styles.innerLink}>
              <CustomerAuditIcon activeLink={activeLink} /> Admin Audit Log
            </div>
          </Link>
        )}
        <div className={styles.dropdown}>
          <Link
            to="/reports"
            className={`${styles.dropdownToggle} ${activeLink === "report" && styles.active
              }`}
            onClick={() => {
              toggleDropdown();
              handleLinkClick("report");
            }}
          >
            <div className={styles.innerLink}>
              <Report activeLink={activeLink} /> Reports
            </div>
          </Link>

          {isOpen && (
            <ul className={styles.dropdownMenu}>
              {filteredMenu?.map((pre) => (
                <li
                  key={pre?.Menu_id}
                  className={`${pre?.Menu_id === activeReport
                    ? "text-white font-bold"
                    : "text-gray-300"
                    }   px-8 pt-2 pb-3 text-[13px] cursor-pointer`}
                  onClick={() => {
                    dispatch(
                      setActiveReport(pre?.Menu_id),
                      navigate("/reports")
                    );
                    closeNav(false);
                  }}
                >
                  {pre?.Menu_name}
                </li>
              ))}

              {!isRestrictedUser && (
                <li
                  key={916}
                  className={`${916 === activeReport ? "text-white font-bold" : "text-gray-300"
                    }   px-8 pt-2 pb-3 text-[13px] cursor-pointer`}
                  onClick={() => {
                    dispatch(setActiveReport(916), navigate("/reports"));
                    closeNav(false);
                  }}
                >
                  {"Point Expiry"}
                </li>
              )}

              {!isRestrictedUser && (
                <li
                  key={949}
                  className={`${949 === activeReport
                    ? "text-white font-bold"
                    : "text-gray-300"
                    }   px-8 pt-2 pb-3 text-[13px] cursor-pointer`}
                  onClick={() => {
                    dispatch(
                      setActiveReport(949),
                      navigate("/reports")
                    );
                    closeNav(false);
                  }}
                >
                  {"OTP"}
                </li>
              )}

              <li
                key={950}
                className={`${950 === activeReport
                  ? "text-white font-bold"
                  : "text-gray-300"
                  }   px-8 pt-2 pb-3 text-[13px] cursor-pointer`}
                onClick={() => {
                  dispatch(
                    setActiveReport(950),
                    navigate("/reports")
                  );
                  closeNav(false);
                }}
              >
                {"New Enrollment"}
              </li>
            </ul>
          )}
        </div>
        <div className={styles.perxButtonContainer}>
          {/* <Link to="https://greenrewardsdemo.perxclm.com/PerXCLM.php"> */}
          <button className={styles.perxButton} onClick={handleLogoutFn}>
            Log out
          </button>
          {/* </Link> */}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
